import * as service from './service'
export default {
  namespace: 'honourKnightAttendScoreRule',
  state: {
    demoData: {}
  },
  effects: {
    * attendScoreRule ({ payload }, { call, put }) {
      const res = yield call(service.attendScoreRule, payload)
      if (res.data.status === 200) {
        return res.data.data
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
